
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
interface IGraficoBp{

  id: string
  totalLiberados: number
  pesquisasDisparadas: number
  respostasBp: number
  contratados: number

}

export const GraficoBP: React.FC<IGraficoBp> = ({ id, respostasBp, totalLiberados, pesquisasDisparadas, contratados }) => {
  function GerarGrafico(): void {
    const options = {
      series: [
        {
          name: 'Perfis liberados',
          data: [totalLiberados, pesquisasDisparadas, respostasBp, contratados]
        }
      ],

      chart: {
        type: 'bar',
        height: 450,
        width: 405
      },
      colors: ['#474d59', '#af1dbf', '#215cdc', '#ea7413'],
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'top'

          },
          distributed: true
        }
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      title: {
        text: 'Pesquisa BP x contratações'
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: number) {
          return val.toString()
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#000']
        }
      },
      xaxis: {
        categories: ['Perfis Liberados', 'Pesquisas disparadas', 'Respostas BP', 'Contratados']
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [totalLiberados, respostasBp])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
